import React from "react";
import { PageHeader } from "@/components/ui-blocks/PageHeader";
import { SEO } from "@/lib/seo";
import { Link } from "react-router-dom";
import { Sparkles, Megaphone, Rocket } from "lucide-react";

export default function YouthVoicePage() {
  return (
    <main>
      <SEO title="Youth Voice" description="CAF Youth Voice — the fellowship, campus chapters and youth-led civic action." breadcrumbs={[{name: "Home", href:"/"},{name:"Youth Voice", href:"/youth-voice"}]} />
      <PageHeader eyebrow="Youth Voice" title="Youth can lead India." lead="CAF backs young changemakers with a paid Fellowship, campus chapters and mentorship." />
      <section className="container-wide py-12 grid gap-5 md:grid-cols-3">
        {[[Rocket, "CAF Youth Fellowship", "A paid 6-month field fellowship with mentorship, stipend and placement."], [Megaphone, "Campus Chapters", "University clubs that run local awareness and service campaigns."], [Sparkles, "Youth Awards", "Annual recognition for the most impactful young volunteers."]].map(([Icon, t, d]) => (
          <div key={t} className="rounded-2xl border border-border bg-background p-6 card-lift">
            <div className="h-10 w-10 rounded-md bg-[hsl(var(--surface-tint))] text-foreground grid place-items-center"><Icon className="h-5 w-5" /></div>
            <h3 className="heading-3 mt-3">{t}</h3>
            <p className="text-sm text-[hsl(var(--muted-ink))] mt-2">{d}</p>
          </div>
        ))}
      </section>
      <section className="container-wide pb-12"><div className="rounded-2xl border border-border bg-black text-white p-6"><div className="eyebrow text-[hsl(var(--orange))]">Apply now</div><h3 className="heading-2 text-white mt-2">Cohort 04 applications are open.</h3><p className="text-white/80 mt-2">Fellows commit to a 6-month field program with mentorship and stipend.</p><div className="mt-4"><Link to="/volunteer" className="btn-primary">Apply as a Fellow</Link></div></div></section>
    </main>
  );
}
